import axios from 'axios';
import Vue from 'vue'
import router from "../../src/router/index"
import store from "../../src/store/index"
/*接口配置*/
var __FORMAL_URL = 'http://fx.mobile.ddhing.com'; //正式环境//
var __TEST_URL = 'http://fx.mobile.ddh.com:8285'; //'; //测试环境http
var __SEVER_ROOT = __FORMAL_URL;
var __API_ROOT = __SEVER_ROOT + "/api";

axios.defaults.timeout = 20000;
axios.defaults.baseURL = __API_ROOT;

//http request 拦截器
axios.interceptors.request.use(
  config => {
    if (config.headers.requestShowLoading) { //请求前加载遮罩
      showWaiting();
      config.headers.requestShowLoading = null
      Vue.$deletePropertyInvalid(config.headers, -1); //清除对象值为null的属性
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  response => {
    let loadingEle = document.querySelector('.vux-loading')
    loadingEle.addEventListener("click", function() { //点击loading遮罩关闭遮罩
      loadingEle.style.display = "none"
    }, false)
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * 发送异步ajax请求
 * @param config 配置参数
 * config.requestUri  请求地址
 * config.requestSuccessCallback  请求成功后的回调函数：函数接受数据参数
 * config.requestFailCallback   请求失败后的回调函数：函数接受数据参数
 * config.requestData   请求携带的数据
 */
var defaultWebRequestConfig = {
  'requestUri': '',
  'requestType': 'get',
  'requestData': null, //{}
  "requestContentType": _requestDataType_json,
  "responseDataType": 'json',
  'requestShowLoading': true, //是否显示加载框
  'requestTimeout': 20000,
  'getDataFromAPICallback': null, //接口数据的回调(若返回true则不执行跳过code、msg处理)
  'manageCode': false, //处理code
  'manageCodeBefore': true, //是否在处理业务逻辑之前就先处理code
  'showMessageType': 4, //显示Message方式,默认1=只显示异常code,2=都显示，3=不显示,4=即使code=0但是Success=false时也提示
  'requestSuccessCallback': function(data, status) {},
  'requestFailCallback': function(error) {}
};

export function sendConfigRequest(config) {
  if (!navigator.onLine) {
    Vue.$vux.alert.show({
      title: '提示',
      content: '请求失败，请确认当前网络环境是否正常',
    })
    return;
  }
  var requestParams = _.extend({}, defaultWebRequestConfig, config);
  if (requestParams.requestType.toLowerCase() == "get") {
    if (requestParams.requestUri.indexOf("?") >= 0) {
      requestParams.requestUri += "&time=" + new Date().getTime();
    } else {
      requestParams.requestUri += "?time=" + new Date().getTime();
    }
  }
  var postHeaders = {};
  var SessionKey = !!window.app_userManage ? window.app_userManage.getUserInfo_fromLocalStorage(_SESSION_KEY) : null;
  if (SessionKey && SessionKey != '') {
    postHeaders[_SESSION_KEY] = SessionKey;
  }
  if (!!window.localStorageUtil) { //加载了缓存工具类
    var cid = getSellerNoCurrent();
    if (!!cid) {
      postHeaders.cid = cid;
    }
  }
  /*查询终端类型*/
  var u = navigator.userAgent
  if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    postHeaders.AppKey = "72b7c8e3b3854668a2d5b04f61add104";
  } else if (u.indexOf('iPhone') > -1) {
    postHeaders.AppKey = "c8a21b361f114de1b34a54c7b5d6ccdd";
  } else {
    postHeaders.AppKey = "2b23dce10ba745c98d4d38cfdbe83bd4";
  }
  postHeaders.TimeStamp = new Date().getTime().toString().substr(0, 10);
  postHeaders = _.extend(postHeaders, {
    'Content-Type': requestParams.requestType.toUpperCase() !== "GET" ? requestParams.requestContentType : null
  })
  postHeaders.requestShowLoading = requestParams.requestShowLoading
  axios({
      method: requestParams.requestType.toUpperCase(),
      url: __API_ROOT + requestParams.requestUri,
      headers: postHeaders,
      data: requestParams.requestType.toUpperCase() !== "GET" && requestParams.requestContentType === _requestDataType_json ? JSON.stringify(requestParams.requestData) : null,
      params: requestParams.requestType.toUpperCase() === "GET" ? requestParams.requestData : null,
      responseType: requestParams.responseDataType
    })
    .then(function(response) {
      var data = response.data
      if (requestParams.requestShowLoading) {
        closeWaiting();
      }
      if (requestParams.manageCodeBefore) {
        switch (data["code"]) {
          case 401:
            var showMessage = data["message"];
            if (showMessage == null) {
              showMessage = "登录失效或未登录";
            }
            alert_relogin(null);
            return;
          case 1001:
            /*2018.7.31刘小丰修改*/
            var SessionKey = !!window.app_userManage ? window.app_userManage.getUserInfo_fromLocalStorage(_SESSION_KEY) : null;
            if (SessionKey && SessionKey != '') {
              Vue.$vux.confirm.show({
                title: '游客没有此操作权限',
                content: "是否立即登录/注册?",
                onConfirm() {
                  relogin();
                }
              })
            } else {
              // relogin();
            }
            return;
          case 1002:
            break;
        }
      }
      requestParams.requestSuccessCallback(data, status);
      if (requestParams.getDataFromAPICallback == null || !requestParams.getDataFromAPICallback(data["data"], data["success"], data["message"], data["code"])) {
        if (requestParams.manageCode) {
          manageCodeMsg(requestParams, data);
        }
      }
    })
    .catch(function(error) {
      if (requestParams.requestShowLoading) {
        closeWaiting();
      }
      console.log(error)
      requestParams.requestFailCallback(error)
    })
}

function showWaiting() {
  Vue.$vux.loading.show({
    text: '',
  })
}

function closeWaiting() {
  Vue.$vux.loading.hide()
}

function manageCodeMsg(requestParams, data) {
  if (data != null) {
    var showMessage = data["message"];
    switch (data["code"]) {
      case 0:
        if (data["success"] == true) {
          if (showMessage == null) {
            showMessage = "操作成功";
          }
        } else {
          if (showMessage == null) {
            showMessage = "操作失败";
          }
        }
        break;
      case 400:
        if (showMessage == null) {
          showMessage = "提交数据无效,验证未通过";
        }
        break;
      case 401:
        if (showMessage == null) {
          showMessage = "登录失效或未登录";
        }
        if (requestParams.requestShowLoading) {
          closeWaiting();
        }
        alert_relogin(showMessage);
        return;
      case 429:
        if (showMessage == null) {
          showMessage = "请求太频繁";
        }
        break;
      case 500:
        if (showMessage == null) {
          showMessage = "内部错误";
        }
        break;
      case 4003:
        if (showMessage == null) {
          showMessage = "您的权限不足";
        }
        Vue.$vux.alert.show({
          title: '提示',
          content: "您的权限不足",
        })
        break;
      default:
        break
    }
    switch (requestParams.showMessageType) {
      case 1:
        if (data["code"] != 0) {
          Vue.$vux.toast.show({
            text: showMessage,
          })
        }
        break;
      case 2:
        if (data["success"]) {
          Vue.$vux.toast.show({
            text: showMessage,
          })
        }
        break;
      case 3:
        break;
      case 4:
        if (data["code"] != 0 || !data["success"]) {
          if (showMessage != null && showMessage != "") {
            // Vue.$vux.toast.show({
            //  text: showMessage
            // })
          }
        }
        break;
      default:
        break
    }
  }
}

function alert_relogin(_msg) {
  var SessionKey = !!window.app_userManage ? window.app_userManage.getUserInfo_fromLocalStorage(_SESSION_KEY) : null;
  if (SessionKey && SessionKey != '') {
    var msg = _msg != null ? _msg : "用户登录已失效,请重新登录";
    Vue.$vux.alert.show({
      title: '提示',
      content: msg,
      onHide() {
        relogin();
      }
    })
  } else { //没有登录过时，直接跳转登录页面/*2018.7.31刘小丰修改*/
    relogin();
  }
}

/*打开一个新的路由*/
function openNewRouter(url) {
  let routerUrl = ''; //需要跳转的路由
  let cid = store.state.cid
  let time = new Date().getTime();
  if (!!url && url.indexOf("?") > -1) {
    routerUrl = `${url}&cid=${cid}&time=${time}`
  } else if (!!url && url.indexOf("?") == -1) {
    routerUrl = `${url}?cid=${cid}&time=${time}`
  } else {
    console.log('缺少地址')
    return
  }
  router.replace(routerUrl)
}
/*重新登录*/
function relogin() {
  window.sessionStorageUtil.clear();
  var users_history = window.localStorageUtil.getItem(_USERS_HISTORY);
  window.localStorageUtil.clear();
  window.localStorageUtil.setItem(_USERS_HISTORY, users_history);
  // store.state.pathArr.shift()
  openNewRouter('/login')
}



// WEBPACK FOOTER //
// ./static/utils/http.js